import { Reveal } from "@/components/Reveal";
import { Compare } from "@/components/Compare";
import { ASSETS } from "@/constants/assets";

export const RecentResults = () => (
  <section id="gallery" data-testid="recent-results-section" className="py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] text-turquoise">
          Our work
        </p>
        <h2 className="mt-3 font-display fluid-h2 font-semibold text-navy">
          Recent <span className="italic text-turquoise">Cleaning Results</span>
        </h2>
        <p className="mt-4 text-navy/65 text-lg">
          Real photos from recent carpet and upholstery cleans across Lanarkshire.
          Drag the slider to see the living-room transformation.
        </p>
      </Reveal>

      <div className="mt-12 grid gap-5 sm:grid-cols-2">
        {/* Living room — before/after comparison */}
        <Reveal>
          <figure data-testid="result-card-0" className="relative">
            <Compare
              testId="living-room-slider"
              before={ASSETS.livingRoom}
              after={ASSETS.livingRoomAfter}
              beforeAlt="Living room carpet before cleaning, with cleaning hoses across the floor"
              afterAlt="Freshly cleaned living room carpet after professional cleaning by Lanarkshire Cleaning Company"
              className="aspect-[4/5] sm:aspect-[4/3]"
            />
            <figcaption className="absolute bottom-4 left-4 z-10 rounded-full bg-white/90 px-4 py-1.5 text-sm font-semibold text-navy">
              Living room carpet
            </figcaption>
          </figure>
        </Reveal>

        {/* Sofa — result photo */}
        <Reveal delay={0.1}>
          <figure
            data-testid="result-card-1"
            className="group relative overflow-hidden rounded-3xl ring-1 ring-navy/10 shadow-lg"
          >
            <img
              src={ASSETS.sofa}
              alt="Grey fabric sofa upholstery cleaned by Lanarkshire Cleaning Company"
              loading="lazy"
              className="aspect-[4/5] sm:aspect-[4/3] w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent" />
            <figcaption className="absolute bottom-4 left-4 rounded-full bg-white/90 px-4 py-1.5 text-sm font-semibold text-navy">
              Sofa upholstery
            </figcaption>
          </figure>
        </Reveal>
      </div>
    </div>
  </section>
);
